import {css} from "@panda/css";

const chevronLeftIcon = require("../images/chevron_left.svg") as string;
const chevronRightIcon = require("../images/chevron_right.svg") as string;

/**
 * Base slick slider styles for PandaCSS components.
 * Use with cx() to combine with component-specific styles.
 */
export const slickSliderPandaStyle = css({
    "& .slick-list, & .slick-slider, & .slick-track": {
        position: "relative",
        display: "block"
    },
    "& .slick-loading .slick-slide, & .slick-loading .slick-track": {
        visibility: "hidden"
    },
    "& .slick-slider": {
        userSelect: "none",
        WebkitTouchCallout: "none",
        touchAction: "pan-y",
        WebkitTapHighlightColor: "transparent"
    },
    "& .slick-list": {
        overflow: "hidden",
        margin: 0,
        padding: 0
    },
    "& .slick-list:focus": {
        outline: 0
    },
    "& .slick-list.dragging": {
        cursor: "pointer"
    },
    "& .slick-slider .slick-list, & .slick-slider .slick-track": {
        transform: "translate3d(0, 0, 0)"
    },
    "& .slick-track": {
        top: 0,
        left: 0
    },
    "& .slick-track:after": {
        clear: "both"
    },
    "& .slick-slide": {
        display: "block",
        float: "left",
        height: "100%",
        minHeight: "1px"
    },
    "& .slick-slide:focus, & .slick-slide:active": {
        outline: 0,
        border: "none"
    },
    "& .slick-slide > div:focus, & .slick-slide > div:active": {
        outline: 0,
        border: "none"
    },
    "& [dir='rtl'] .slick-slide": {
        float: "right"
    },
    "& .slick-slide img": {
        display: "block"
    },
    "& .slick-slide.slick-loading img": {
        display: "none"
    },
    "& .slick-slide.dragging img": {
        pointerEvents: "none"
    },
    "& .slick-vertical .slick-slide": {
        display: "block",
        height: "auto",
        border: "1px solid transparent"
    },
    "& .slick-arrow.slick-hidden": {
        display: "none"
    },
    "& .slick-dots, & .slick-next, & .slick-prev": {
        position: "absolute",
        display: "block",
        padding: 0
    },
    "& .slick-next, & .slick-prev": {
        fontSize: 0,
        lineHeight: 0,
        top: "50%",
        width: "20px",
        height: "20px",
        transform: "translate(0, -50%)",
        cursor: "pointer",
        color: "transparent",
        border: "none",
        outline: 0,
        background: "none"
    },
    "& .slick-arrow:focus, & .slick-arrow:hover": {
        outline: 0
    },
    "& .slick-arrow:focus:before, & .slick-arrow:hover:before": {
        opacity: 1
    },
    "& .slick-arrow.slick-disabled:before": {
        opacity: 0.25
    },
    "& .slick-prev": {
        left: 0
    },
    "& [dir='rtl'] .slick-prev": {
        right: "-25px",
        left: "auto"
    },
    "& .slick-prev:before": {
        content: "''",
        backgroundImage: `url("${chevronLeftIcon}")`,
        left: 0,
        transform: "translateX(-50%)"
    },
    "& .slick-next:before, & [dir='rtl'] .slick-prev:before": {
        content: "''"
    },
    "& .slick-next": {
        right: 0
    },
    "& [dir='rtl'] .slick-next": {
        right: "auto",
        left: "-25px"
    },
    "& .slick-next:before": {
        backgroundImage: `url("${chevronRightIcon}")`,
        right: "-2.4rem"
    },
    "& .slick-dotted.slick-slider": {
        marginBottom: "30px"
    },
    "& .slick-dots": {
        bottom: "-25px",
        width: "100%",
        margin: 0,
        listStyle: "none",
        textAlign: "center"
    },
    "& .slick-dots li": {
        position: "relative",
        display: "inline-block",
        width: "20px",
        height: "20px",
        margin: "0 5px",
        padding: 0,
        cursor: "pointer"
    },
    "& .slick-dots li button": {
        fontSize: 0,
        lineHeight: 0,
        display: "block",
        width: "20px",
        height: "20px",
        padding: "5px",
        cursor: "pointer",
        color: "transparent",
        border: 0,
        outline: 0,
        background: "none"
    },
    "& .slick-dots li button:focus, & .slick-dots li button:hover": {
        outline: 0
    },
    "& .slick-dots li button:focus:before, & .slick-dots li button:hover:before": {
        opacity: 1
    },
    "& .slick-dots li button:before": {
        fontSize: "6px",
        lineHeight: "20px",
        position: "absolute",
        top: 0,
        left: 0,
        width: "20px",
        height: "20px",
        content: "'•'",
        textAlign: "center",
        opacity: 0.25,
        color: "#000"
    },
    "& .slick-dots li.slick-active button:before": {
        opacity: 0.75,
        color: "#000"
    },
    "& .slick-arrow": {
        height: "100%",
        width: "100px",
        zIndex: 1
    },
    "& .slick-arrow:before": {
        fontSize: "20px",
        lineHeight: 1,
        zIndex: 1,
        width: "4.8rem",
        height: "4.8rem",
        borderRadius: "50%",
        backgroundColor: "#ebff00",
        color: "white",
        position: "absolute",
        top: "50%",
        marginTop: "-2.2rem",
        content: "''",
        backgroundSize: "50%",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat"
    },
    "& .slick-disabled": {
        display: "none !important"
    }
});
import {css} from "@panda/css";

const chevronLeftIcon = require("../images/chevron_left.svg") as string;
const chevronRightIcon = require("../images/chevron_right.svg") as string;

/**
 * Base slick slider styles for PandaCSS components.
 * Use with cx() to combine with component-specific styles.
 */
export const slickSliderPandaStyle = css({
    "& .slick-list, & .slick-slider, & .slick-track": {
        position: "relative",
        display: "block"
    },
    "& .slick-loading .slick-slide, & .slick-loading .slick-track": {
        visibility: "hidden"
    },
    "& .slick-slider": {
        userSelect: "none",
        WebkitTouchCallout: "none",
        touchAction: "pan-y",
        WebkitTapHighlightColor: "transparent"
    },
    "& .slick-list": {
        overflow: "hidden",
        margin: 0,
        padding: 0
    },
    "& .slick-list:focus": {
        outline: 0
    },
    "& .slick-list.dragging": {
        cursor: "pointer"
    },
    "& .slick-slider .slick-list, & .slick-slider .slick-track": {
        transform: "translate3d(0, 0, 0)"
    },
    "& .slick-track": {
        top: 0,
        left: 0
    },
    "& .slick-track:after": {
        clear: "both"
    },
    "& .slick-slide": {
        display: "block",
        float: "left",
        height: "100%",
        minHeight: "1px"
    },
    "& .slick-slide:focus, & .slick-slide:active": {
        outline: 0,
        border: "none"
    },
    "& .slick-slide > div:focus, & .slick-slide > div:active": {
        outline: 0,
        border: "none"
    },
    "& [dir='rtl'] .slick-slide": {
        float: "right"
    },
    "& .slick-slide img": {
        display: "block"
    },
    "& .slick-slide.slick-loading img": {
        display: "none"
    },
    "& .slick-slide.dragging img": {
        pointerEvents: "none"
    },
    "& .slick-vertical .slick-slide": {
        display: "block",
        height: "auto",
        border: "1px solid transparent"
    },
    "& .slick-arrow.slick-hidden": {
        display: "none"
    },
    "& .slick-dots, & .slick-next, & .slick-prev": {
        position: "absolute",
        display: "block",
        padding: 0
    },
    "& .slick-next, & .slick-prev": {
        fontSize: 0,
        lineHeight: 0,
        top: "50%",
        width: "20px",
        height: "20px",
        transform: "translate(0, -50%)",
        cursor: "pointer",
        color: "transparent",
        border: "none",
        outline: 0,
        background: "none"
    },
    "& .slick-arrow:focus, & .slick-arrow:hover": {
        outline: 0
    },
    "& .slick-arrow:focus:before, & .slick-arrow:hover:before": {
        opacity: 1
    },
    "& .slick-arrow.slick-disabled:before": {
        opacity: 0.25
    },
    "& .slick-prev": {
        left: 0
    },
    "& [dir='rtl'] .slick-prev": {
        right: "-25px",
        left: "auto"
    },
    "& .slick-prev:before": {
        content: "''",
        backgroundImage: `url("${chevronLeftIcon}")`,
        left: 0,
        transform: "translateX(-50%)"
    },
    "& .slick-next:before, & [dir='rtl'] .slick-prev:before": {
        content: "''"
    },
    "& .slick-next": {
        right: 0
    },
    "& [dir='rtl'] .slick-next": {
        right: "auto",
        left: "-25px"
    },
    "& .slick-next:before": {
        backgroundImage: `url("${chevronRightIcon}")`,
        right: "-2.4rem"
    },
    "& .slick-dotted.slick-slider": {
        marginBottom: "30px"
    },
    "& .slick-dots": {
        bottom: "-25px",
        width: "100%",
        margin: 0,
        listStyle: "none",
        textAlign: "center"
    },
    "& .slick-dots li": {
        position: "relative",
        display: "inline-block",
        width: "20px",
        height: "20px",
        margin: "0 5px",
        padding: 0,
        cursor: "pointer"
    },
    "& .slick-dots li button": {
        fontSize: 0,
        lineHeight: 0,
        display: "block",
        width: "20px",
        height: "20px",
        padding: "5px",
        cursor: "pointer",
        color: "transparent",
        border: 0,
        outline: 0,
        background: "none"
    },
    "& .slick-dots li button:focus, & .slick-dots li button:hover": {
        outline: 0
    },
    "& .slick-dots li button:focus:before, & .slick-dots li button:hover:before": {
        opacity: 1
    },
    "& .slick-dots li button:before": {
        fontSize: "6px",
        lineHeight: "20px",
        position: "absolute",
        top: 0,
        left: 0,
        width: "20px",
        height: "20px",
        content: "'•'",
        textAlign: "center",
        opacity: 0.25,
        color: "#000"
    },
    "& .slick-dots li.slick-active button:before": {
        opacity: 0.75,
        color: "#000"
    },
    "& .slick-arrow": {
        height: "100%",
        width: "100px",
        zIndex: 1
    },
    "& .slick-arrow:before": {
        fontSize: "20px",
        lineHeight: 1,
        zIndex: 1,
        width: "4.8rem",
        height: "4.8rem",
        borderRadius: "50%",
        backgroundColor: "#ebff00",
        color: "white",
        position: "absolute",
        top: "50%",
        marginTop: "-2.2rem",
        content: "''",
        backgroundSize: "50%",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat"
    },
    "& .slick-disabled": {
        display: "none !important"
    }
});
